module.exports = __webpack_public_path__ + "img/sa.01c13e57.png";